import { SearchIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Flex,
  Grid,
  Input,
  InputGroup,
  InputRightAddon,
  InputRightElement,
  Text,
} from "@chakra-ui/react";
import { useEffect, useMemo, useState } from "react";
import { CourseIcon } from "../../_shared/CourseIcon";
import { CreateCourseButton } from "../_shared/CreateCourseButton";
import { UserSidebar } from "../_shared/Sidebar";
import { useMyUserGroupQuery } from "./index.generated";

export const UserMyUserGroup = () => {
  const [myUserGroupRes] = useMyUserGroupQuery();
  const userGroup = myUserGroupRes.data?.myUserGroup;
  if (!userGroup) return null;
  const courses = userGroup.courses;
  courses.sort((a, b) => {
    if (a.updatedAt > b.updatedAt) return -1;
    else {
      return 1;
    }
  });

  const isActiveRouteChangeAlertFlag = useMemo(() => {
    return myUserGroupRes.data?.appConfig.routeChangeAlert;
  }, [myUserGroupRes.data?.appConfig.routeChangeAlert]);

  const [searchedWord, setSearchedWord] = useState("");
  const [filteredCourses, setFilteredCourses] = useState(courses || []);

  useEffect(() => {
    if (searchedWord === "") {
      setFilteredCourses(courses);
      return;
    }
    const filtered = courses.filter((course) => {
      return course.name.includes(searchedWord);
    });
    setFilteredCourses(filtered);
  }, [searchedWord, myUserGroupRes]);

  return (
    <Flex flexGrow={1}>
      <UserSidebar />
      <Box bgColor={"#16181a"} flexGrow={1} px={10} py={14}>
        <Flex
          flexDir="row"
          flexWrap="wrap"
          alignItems="center"
          justifyContent="space-between"
          py={2}
          my={4}
        >
          <Text
            fontSize="4xl"
            fontWeight="bold"
            noOfLines={1}
            justifyItems="center"
            textColor="white"
          >
            コース一覧
          </Text>
          <InputGroup
            maxW={300}
            w={"full"}
            display={{ base: "none", md: "flex" }}
          >
            <Input
              placeholder="検索"
              _placeholder={{ color: "gray.500" }}
              onChange={(event) => {
                setSearchedWord(event.target.value);
              }}
              maxW={300}
              textColor="white"
            />
            <InputRightElement
              pointerEvents="none"
              children={<SearchIcon color="gray.500" />}
            />
          </InputGroup>

          <Flex gap={2}>
            <CreateCourseButton />
          </Flex>
        </Flex>
        {filteredCourses.length === 0 ? (
          <Text fontSize={20} fontWeight="bold" textColor={"white"}>
            該当するコースが存在しません。
          </Text>
        ) : (
          <Grid templateColumns="repeat(5, 1fr)" gap={8} mb={4}>
            {filteredCourses.map((course, idx) => {
              return (
                <CourseIcon
                  key={course.id}
                  course={course}
                  isViewMode={false}
                  isActiveRouteChangeAlertFlag={isActiveRouteChangeAlertFlag}
                />
              );
            })}
          </Grid>
        )}
      </Box>
    </Flex>
  );
};
